(function() {
    'use strict';
    const trackingUtils = require('../modules/utils/tracking.utils');
    const tagManagement = require('../modules/utils/tag_management.utils');
    const trackingPageFlowUtils = require('../modules/utils/flow_tracking/tracking.page.flow.utils');
    const handler3DS = require('../modules/3ds/index').default;
    const stopAndCountMetrics = () => {
        handler3DS.composePsd2Metric('3DS_TIME_ERROR', '_FLIGHTS_', 'stopMetric');
    };

    const trackingPageFlowType = {
        ADD: 'add',
        ERROR: 'error',
    };

    const trackingPageFlowAppearances = {
        trackingPageFlowAppearancesSettings: {
            flow: 'payment_flow_appearances',
            label: '3ds:ap',
        },
    };

    const sendFlowTracking = (label = '') => {
        trackingPageFlowUtils.launchEvent({
            flow: 'payment_flow_action',
            label: `3ds:${label}`,
        });
    };

    Odigeo.Router.handlers.payment3ds = function() {
        const page = 'payment3ds';
        Odigeo.Session.set('page', page);
        var backEndURL = Odigeo.Settings.property('appContext') + '/service/recoverfromuserinteraction';
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
            Odigeo.Router.handlers.globalEventController,
            Odigeo.Router.handlers.errorManagerEventController, {
                // Global events will remain bound in any part of the application
                globalEvents: {},
                // View or local events which are triggered from this view.
                // They will be unbinded when the view changes.
                viewEvents: {},
                // implementation of events handlers
                eventHandlers: {},
            });
        Odigeo.Router.eventController.execute();

        // Analytics: virtual page tracking
        trackingUtils.trackPage('redirection-3dsecure', {
            legacy: Odigeo.Utils.getFunnelTrackingLegacy() + 'pago/',
            funnel: true,
        });
        tagManagement.updateDatalayer();
        Odigeo.Session.set('payment3ds', 'true');

        trackingPageFlowUtils.launchAppearancesTracking(trackingPageFlowAppearances);
        // eslint-disable-next-line no-restricted-properties
        $.ajax({
            type: 'GET',
            url: backEndURL,
            success: function(msg) {
                const bookingId = msg && msg.myTrip && msg.myTrip.bookingId || '';
                handler3DS.sendLogToKibana(`RECOVER_FROM_USER_INTERACTION_${bookingId}`, '_FLIGHTS_');
                if (Odigeo._.isEmpty(msg)) {
                    stopAndCountMetrics();
                    Odigeo.UIElements.showBrokenFlowError('alert', true);
                    Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                    sendFlowTracking(trackingPageFlowType.ERROR);
                } else if (msg.errors) {
                    stopAndCountMetrics();
                    var error = msg.errors[0];
                    if (error.code === 'SESSION_EXPIRED_ERROR') {
                        handler3DS.sendLogToKibana(`CONFIRMATION_3DSECURE_SESSION_EXPIRED_ERROR_${bookingId}`, '_FLIGHTS_');
                        Odigeo.UIElements.showSessionExpiredError('alert', true);
                    } else {
                        handler3DS.sendLogToKibana(`CONFIRMATION_3DSECURE_BROKEN_FLOW_ERROR_${bookingId}`, '_FLIGHTS_');
                        Odigeo.UIElements.showBrokenFlowError('alert', true);
                    }
                    Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                    sendFlowTracking(trackingPageFlowType.ERROR);
                } else if (msg.bookingStatus === 'BOOKING_PAYMENT_RETRY' &&
                    msg.myTrip.paymentRetryInfo.paymentDetails.method !== 'SOFORT') {
                    // it's probable that this condition is not necessary,
                    // but must be checked for 3ds payment other than SOFORT
                    Odigeo.requireWidget('payment-manager', 'paymentmanager', function(widget) {
                        widget.execute('paymentRetry', msg);
                    });
                    sendFlowTracking(trackingPageFlowType.ERROR);
                    stopAndCountMetrics();
                    Odigeo.Router.navigate('payment');
                } else {
                    sendFlowTracking(trackingPageFlowType.ADD);
                    if (msg.bookingStatus === 'BOOKING_USER_INTERACTION') {
                        Odigeo.Session.set('resumeBookingStep', 1);
                    } else {
                        const resumeBookingStep = parseInt(Odigeo.Session.get('resumeBookingStep'), 10);
                        Odigeo.Session.set('resumeBookingStep', resumeBookingStep ? 2 : 1);
                    }

                    Odigeo.Router.navigate('confirmation');

                    var confirmationData = {
                        'bookingstatus': msg.bookingStatus,
                        'repricing': msg.repricing,
                        'extensions': msg.extensions,
                        'myTrip': msg.myTrip,
                        'membershipPerksDTO': msg.membershipPerksDTO,
                        'userInteractionNeededDTO': msg.userInteractionNeededDTO || null,
                        'analyticsEcommerce': msg.analyticsEcommerce,
                    };

                    if (confirmationData.bookingstatus === 'BOOKING_CONFIRMED') {
                        handler3DS.sendLogToKibana(`CONFIRMATION_3DSECURE_SUCCESS_${bookingId}`, '_FLIGHTS_');
                        handler3DS.composePsd2Metric('3DS_TIME', '_FLIGHTS_', 'stopMetric');
                    } else {
                        handler3DS.sendLogToKibana(`CONFIRMATION_3DSECURE_${confirmationData.bookingstatus}_${bookingId}`, '_FLIGHTS_');
                    }

                    Odigeo._.delay(function() {
                        Odigeo.trigger('payment-manager' + ':confirmationReady', confirmationData);
                    }, 1000);
                }
            },
            error: function(data) {
                Odigeo.Model.prototype.afterLoadData(data);
            },
        });
    };
}());
